export const initialState = {
    countryStats: [],
    darkmode: false,
    legendTitles: [],
    outerWidth: null,
    searchText: '',
    selected: null,
}

const reducer = (state, action) => {
    console.log(action)
    switch(action.type) {
        case 'UPDATE_COUNTRY_STATS':
            return { 
                ...state,
                countryStats: action.item
            }
        case 'UPDATE_DARKMODE':
            return { 
                ...state,
                darkmode: action.item
            }
        case 'UPDATE_LEGEND_TITLES':
            return { 
                ...state,
                legendTitles: action.item
            }
        case 'UPDATE_OUTER_WIDTH':
            return { 
                ...state,
                outerWidth: action.item
            }  
        case 'UPDATE_SEARCHTEXT':
            return { 
                ...state,
                searchText: action.item
            }
        case 'UPDATE_SELECTED':
            return { 
                ...state,
                selected: action.item
            }
        default:
            return state  
    }
}

export default reducer